import { Gift, TicketPercent } from "lucide-react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui";
import { formatCurrency } from "@/lib/utils";
import type { GiveawayImpact } from "@/types";

interface GiveawayCardProps {
  data: GiveawayImpact;
  totalRevenue: number;
}

export function GiveawayCard({ data, totalRevenue }: GiveawayCardProps) {
  const totalGiveaway = data.totalDiscount + data.compedValue;
  const compShare =
    totalRevenue > 0 ? totalGiveaway / (totalRevenue + totalGiveaway) : 0;

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Gift className="h-5 w-5" />
          Discounts &amp; comps
        </CardTitle>
        <CardDescription>
          {totalGiveaway > 0
            ? `${(compShare * 100).toFixed(1)}% of gross given away`
            : "Nothing given away this period"}
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-3">
        <Row
          icon={TicketPercent}
          label="Promo discounts"
          value={formatCurrency(data.totalDiscount)}
          hint={`${data.promotionalOrders} orders used a promo`}
        />
        <Row
          icon={Gift}
          label="Comped items"
          value={formatCurrency(data.compedValue)}
          hint={`${data.compedItems} items comped`}
        />
      </CardContent>
    </Card>
  );
}

function Row({
  icon: Icon,
  label,
  value,
  hint,
}: {
  icon: React.ElementType;
  label: string;
  value: string;
  hint: string;
}) {
  return (
    <div className="flex items-center justify-between rounded-md border p-3">
      <div className="flex items-center gap-3">
        <Icon className="h-4 w-4 text-muted-foreground" />
        <div>
          <p className="font-medium">{label}</p>
          <p className="text-xs text-muted-foreground">{hint}</p>
        </div>
      </div>
      <span className="font-semibold">{value}</span>
    </div>
  );
}
